export const COMPANION_OAUTH_REAUTHENTICATION_REQUIRED =
  "oauth_reauthentication_required";

export const isCompanionOAuthReauthenticationRequired = (error: any) => {
  const status = Number(
    error?.statusCode ?? error?.status ?? error?.response?.status ?? 0
  );
  const code =
    error?.data?.code ??
    error?.data?.data?.code ??
    error?.response?._data?.code ??
    error?.response?._data?.data?.code;

  return (
    status === 401 && code === COMPANION_OAUTH_REAUTHENTICATION_REQUIRED
  );
};
